import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export function SecondLevelSelector({
  analysis,
  selectedSecondLevels,
  onToggle,
  onSelectAll,
  onClear,
}) {
  const subdivisions = analysis.coastal_subdivisions || [];

  return (
    <Card className="bg-slate-900/50 border-slate-800" data-testid="second-level-selection">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Step 4: Select Coastal {analysis.subdivision_type}s</CardTitle>
            <CardDescription>{selectedSecondLevels.length} of {subdivisions.length} selected</CardDescription>
          </div>
          <div className="flex gap-2">
            <Button data-testid="btn-select-all-second" variant="outline" size="sm" onClick={onSelectAll} className="border-slate-700">Select All</Button>
            <Button data-testid="btn-clear-second" variant="outline" size="sm" onClick={onClear} className="border-slate-700">Clear</Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-48">
          <div className="grid grid-cols-3 gap-2">
            {subdivisions.map((sub) => {
              const name = sub.name || sub;
              const size = sub.size || "medium";
              const selected = selectedSecondLevels.includes(name);
              return (
                <div
                  key={`sl-${name}`}
                  data-testid={`second-level-item-${name}`}
                  onClick={() => onToggle(name)}
                  className={`flex items-center gap-2 p-2 rounded cursor-pointer ${
                    selected
                      ? "bg-cyan-500/20 border border-cyan-500/50"
                      : "bg-slate-800/50 hover:bg-slate-700/50 border border-transparent"
                  }`}
                >
                  <Checkbox checked={selected} className="pointer-events-none" />
                  <span className="flex-1 truncate">{name}</span>
                  <Badge variant="outline" className="text-xs">{size}</Badge>
                </div>
              );
            })}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
